import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { MenuItem, MessageService } from 'primeng/api';
import { AdamsDocModel } from '../../models/adams-doc-model';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-doc-properties-view',
  templateUrl: './doc-properties-view.component.html',
  styleUrls: ['./doc-properties-view.component.css']
})
export class DocPropertiesViewComponent implements OnInit {

  item: AdamsDocModel = {};
  loading = false;

  constructor(private actRouter: ActivatedRoute,
    private loaderSvc: LoaderService) {

  }

  ngOnInit(): void {
    this.subscribeLoader();
    this.actRouter.data.subscribe((d: any) => {
      this.item = d.props;
    });
  }

  subscribeLoader() {
    this.loaderSvc.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }
}
